import { cn } from '@/lib/utils';

interface EngravedBackgroundProps {
  className?: string;
  opacity?: number;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  position?: 'center' | 'right' | 'left';
}

const sizeClasses = {
  sm: 'w-64 h-64',
  md: 'w-96 h-96',
  lg: 'w-[500px] h-[500px]',
  xl: 'w-[700px] h-[700px]',
};

const positionClasses = {
  center: 'left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
  right: 'right-0 top-1/2 -translate-y-1/2 translate-x-1/4',
  left: 'left-0 top-1/2 -translate-y-1/2 -translate-x-1/4',
};

/**
 * Engraved 3D logo background effect
 * Creates a subtle embossed/debossed effect using the cloud logo
 */
export function EngravedBackground({
  className,
  opacity = 0.03,
  size = 'lg',
  position = 'center',
}: EngravedBackgroundProps) {
  return (
    <div
      className={cn(
        'pointer-events-none absolute',
        sizeClasses[size],
        positionClasses[position],
        className
      )}
      aria-hidden="true"
    >
      {/* Main shadow layer - creates depth */}
      <img
        src="/logo/logo-icon.png"
        alt=""
        className="absolute inset-0 h-full w-full object-contain"
        style={{
          opacity: opacity,
          filter: 'grayscale(100%) brightness(0)',
        }}
      />
      {/* Highlight layer - creates 3D emboss effect */}
      <img
        src="/logo/logo-icon.png"
        alt=""
        className="absolute inset-0 h-full w-full object-contain"
        style={{
          opacity: opacity * 0.5,
          filter: 'grayscale(100%) brightness(2) blur(1px)',
          transform: 'translate(-2px, -2px)',
        }}
      />
    </div>
  );
}
